<div class="footer-proof">
  <div class="column footer-c">


    <div id="apg-d653c118-9b0f-428b-b12d-624aa6833c25" data-apg-seal-id="d653c118-9b0f-428b-b12d-624aa6833c25"
         data-apg-image-size="64" data-apg-image-type="basic-small"></div>

    <div class="footer-copyright-wrap">
      <h6>&copy; 2019 edgeless.io All rights reserved.</h6>
      <p class="footer-licence-desc">This Service operates under the License No. 8048/JAZ issued to
        Antillephone, Authorized and Regulated by the Government of Curacao.</p>
    </div>
  </div>
  <div class="column footer-c-2">
    <h6>Join us on social media</h6>
    <div class="footer-social-column">
      <a href="https://twitter.com/edgelessproject" rel="noopener" target="_blank" data-id="footer-twitter-href" >
        <i class="fab fa-twitter"></i>
      </a>
      <a href="https://www.reddit.com/r/Edgeless/" rel="noopener" target="_blank" data-id="footer-reddit-href">
        <i class="fab fa-reddit"></i>
      </a>
      <a href="https://bitcointalk.org/index.php?topic=1718384.0" rel="noopener" target="_blank"
         data-id="footer-bitcointalk-href">
        <i class="fab fa-btc"></i>
      </a>
      <a href="https://github.com/edgeless-casino/" rel="noopener" target="_blank" data-id="footer-github-href">
        <i class="fab fa-github"></i>
      </a>
    </div>
  </div>
</div>
<div class="footer-container">
  <div class="pages-footer-column footer-columns" *ngFor="let category of links">
    <h6>{{ category.name }}</h6>
    <ng-container *ngFor="let link of category.items">
      <a *ngIf="link.href" [href]="link.href" target="_blank" rel="noopener" class="footer-link"
         data-id="footer-{{ link.id }}-link">
        {{ link.name
        }}
      </a>
      <a *ngIf="link.routerLink" [routerLink]="link.routerLink" class="footer-link"
         data-id="footer-{{ link.id }}-link">
        {{ link.name }}
      </a>
    </ng-container>
  </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/footer/footer.template.html